import {Button} from "antd";

export interface RegStepMicrosoftWelcomeProps {
  firstName: string;
  toDashboard: () => void;
}

export default function RegStepMicrosoftWelcome({firstName, toDashboard}: RegStepMicrosoftWelcomeProps) {
  return (
    <div className={"success-next step full"}>
      <div className="emoji">&#128075;</div>
      <h2>Welcome, {firstName}.</h2>
      <p>You've been added to the SSA Group workspace.</p>

      <footer>
        <Button size={"large"} className={"primary"} onClick={toDashboard}>Continue</Button>
      </footer>
    </div>
  );
}
